import React from 'react';

// Base skeleton component with shimmer animation
const Skeleton = ({ width, height, variant = 'text', className = '' }) => {
  const style = {
    width: width || '100%',
    height: height || (variant === 'text' ? '1rem' : 'auto'),
  };

  return (
    <div className={`skeleton skeleton-${variant} ${className}`} style={style} aria-hidden="true" />
  );
};

// Skeleton for blog list item
export const PostSkeleton = () => (
  <div className="post-skeleton" aria-label="Loading post">
    <Skeleton variant="text" width="70%" height="1.5rem" className="skeleton-title" />
    <Skeleton variant="text" width="100%" height="1rem" className="skeleton-excerpt" />
    <Skeleton variant="text" width="90%" height="1rem" className="skeleton-excerpt" />
    <div className="skeleton-meta">
      <Skeleton variant="text" width="80px" height="1.5rem" className="skeleton-badge" />
      <Skeleton variant="text" width="60px" height="1.25rem" className="skeleton-tag" />
    </div>
  </div>
);

// Multiple post skeletons
export const PostListSkeleton = ({ count = 5 }) => (
  <div className="post-list-skeleton" aria-busy="true" aria-label="Loading posts">
    {Array.from({ length: count }).map((_, i) => (
      <PostSkeleton key={i} />
    ))}
  </div>
);

// Skeleton for archive items
export const ArchiveSkeleton = ({ count = 10 }) => (
  <div className="archive-skeleton" aria-busy="true" aria-label="Loading archive">
    <Skeleton variant="text" width="150px" height="1.25rem" className="skeleton-month" />
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="archive-item-skeleton">
        <Skeleton variant="text" width="24px" height="1rem" />
        <Skeleton variant="text" width={`${60 + Math.random() * 30}%`} height="1rem" />
      </div>
    ))}
  </div>
);

export default Skeleton;
